import { combineReducers } from 'redux';

import main from './main.js';
import dashboard from './dashboard.js';
import logs from './logs.js';
import health from './health.js';
import forms from './forms.js';
import users from './users.js';
import user from './user.js';
import statistics from './statistics.js';
import scam from './scam.js';
import templates from './templates.js';
import changelog from './changelog.js';
import customCode from './customCode.js';

const rootReducer = combineReducers({
  main,
  dashboard,
  logs,
  health,
  forms,
  users,
  user,
  statistics,
  scam,
  customCode,
  templates,
  changelog
});

export default rootReducer;
